import GenericDB from './generic-db';

export default class ChartPhaseLinesDB extends GenericDB {
  constructor() {
    super('chartPhaseLines');
  }

  readPhaseLineScope(clinic, client, chartPhaseLineScope) {
    const query = [
      ['client', '==', client],
      ['clinic', '==', clinic],
      ['scope', '==', chartPhaseLineScope.scope],
    ];
    if (['program', 'target', 'subTarget'].includes(chartPhaseLineScope.scope)) {
      query.push(['program', '==', chartPhaseLineScope.program]);
    }
    if (['target', 'subTarget'].includes(chartPhaseLineScope.scope)) {
      query.push(['target', '==', chartPhaseLineScope.target]);
    }
    return this.readAll(query);
  } // readPhaseLineScope()
}
